/*
 * @Author: 孙福聪
 * @Date: 2018-08-27 11:55:03
 * @Last Modified by: 孙福聪
 * @Last Modified time: 2019-01-04 15:22:03
 */

// 导入模块
import api from "./api";
const install = function apiFun(Vue) {
  if (install.installed) return;
  install.installed = true;
  // 定义属性到Vue原型中
  Object.defineProperties(Vue.prototype, {
    $http: {
      get() {
        return api;
      }
    }
  });
};

export default {
  install
};
